/**
 * initDarkMode
 * @description Initializes dark mode logic with local storage persistence
 */
export default function initDarkMode() {
  const htmlElement = document.documentElement;

  const syncCheckbox = isDark => {
    const darkModeToggle = document.querySelector('#toggleDarkMode');
    if (darkModeToggle) {
      darkModeToggle.checked = isDark;
    }
  };

  const setDarkMode = isDark => {
    if (isDark) {
      htmlElement.setAttribute('data-bs-theme', 'dark');
      localStorage.setItem('theme', 'dark');
    } else {
      htmlElement.setAttribute('data-bs-theme', 'light');
      localStorage.setItem('theme', 'light');
    }
    syncCheckbox(isDark);
  };

  // Initial Theme Setup
  const savedTheme = localStorage.getItem('theme');
  let isDarkMode = false;

  if (savedTheme) {
    isDarkMode = savedTheme === 'dark';
  } else {
    // Padrão PMV: Light Mode no primeiro acesso
    isDarkMode = false;
  }

  htmlElement.setAttribute('data-bs-theme', isDarkMode ? 'dark' : 'light');

  // Listeners
  document.addEventListener('DOMContentLoaded', () => {
    syncCheckbox(isDarkMode);

    document.addEventListener('change', e => {
      if (e.target && e.target.id === 'toggleDarkMode') {
        setDarkMode(e.target.checked);
      }
    });

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          syncCheckbox(localStorage.getItem('theme') === 'dark');
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  });

  window.addEventListener('storage', e => {
    if (e.key === 'theme') {
      const isDark = e.newValue === 'dark';
      htmlElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');
      syncCheckbox(isDark);
    }
  });
}
